module.exports = __webpack_public_path__ + "img/1.9a267487.jpg";